import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import './subscription.scss';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import { getSubscriptionData } from '../reducer';
import {
  deleteSubscriptionType, loadSubscriptionTypeById, loadSubscriptionTypeByIdClear, loadSubscriptionTypeList,
} from '../actions';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  responseLogWithNotification,
  getPaginationOpts,
  getJsonFromStorage,
  useUpdatePeriod,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { getSystemData } from '../../System/reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { subscriptionPresetColumns } from '../constants';
import Pagination from '../../../components/base/Pagination/Pagination';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { showGlobalConfirm } from '../../System/actions';
import notificationDecorator from '../../Notifications/notificationDecorator';
import IconBox from '../../../components/common/IconBox';
import SubscriptionPresetForm from './SubscriptionPresetForm';

export default function SubscriptionPresetPage() {
  const dispatch = useDispatch();
  const [isCreate, setCreate] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const {
    subscriptionTypeList,
    subscriptionTypeListMeta,
    loadingSubscriptionTypeList,
    currentSubscriptionType,
    loadingCurrentSubscriptionType,
    loadingCreateSubscriptionType,
    loadingEditSubscriptionType,
    loadingDeleteSubscriptionType,
  } = useSelector(getSubscriptionData);

  const { updatePeriod } = useSelector(getSystemData);

  const initial = getJsonFromStorage('subs-filter', {});
  const { getValues, watch, control } = useForm({ defaultValues: { ...initial } });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(subscriptionTypeListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadSubscriptionTypeList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    const subscriptionType = watch(values => { loadData(); });
    return () => subscriptionType.unsubscribe();
  }, [watch]);

  const handleCreate = () => {
    setCreate(true);
    setShowForm(true);
  };

  const handleView = item => e => {
    dispatch(loadSubscriptionTypeById(item.id))
      .then(() => {
        setShowView(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleEdit = item => e => {
    dispatch(loadSubscriptionTypeById(item.id))
      .then(() => {
        setShowForm(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleActive = item => e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDelete = item => e => {
    dispatch(showGlobalConfirm({
      confirmTitle: 'Удаление пресета',
      confirmMessage: `Вы уверены, что хотите удалить пресет ${item.id}?`,
      confirmButtonText: 'Удалить',
    })).then(() => {
      dispatch(deleteSubscriptionType(item.id))
        .then(() => {
          loadData();
          notificationDecorator({
            title: 'Удаление пресета',
            message: 'Успешно',
          });
        })
        .catch(responseLogWithNotification);
    }).catch(() => {});
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(loadSubscriptionTypeByIdClear());
    setShowForm(false);
    setShowView(false);
    setCreate(false);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleView(item)}>
            Просмотреть
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
            Редактировать
          </Button>
          <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const renderList = () => (
    <div className="page-container">
      <div className="inputs-box">
        <PageHeader header="Пресеты" />
        <div className="inputs">
          <IconBox icon="plus-add" onClick={handleCreate} />
        </div>
      </div>
      <div className="plp-table g-0">
        <div className="frame">
          <div className="sticky-table-wrapper custom-scroll-theme">
            <CustomizedGrid
              className="plp-grid"
              data={subscriptionTypeList}
              columns={subscriptionPresetColumns}
              name="subs-preset-list"
              settingsFormatter={moreFormatter}
              onDoubleClickByRow={(item, event) => handleView(item)(event)}
            />
          </div>
        </div>
        <Pagination meta={subscriptionTypeListMeta} list={subscriptionTypeList} handleChangeMeta={loadData} />
      </div>
    </div>
  );

  const isForm = showForm && (currentSubscriptionType || isCreate);
  const isView = showView && currentSubscriptionType;

  return (
    <div className="subscription-tab">
      <Loader global loading={loadingSubscriptionTypeList || loadingCurrentSubscriptionType || loadingCreateSubscriptionType || loadingEditSubscriptionType || loadingDeleteSubscriptionType} />
      {!isForm && !isView ? renderList() : null}
      {!isForm && isView ? <SubscriptionPresetForm hasView handleEdit={handleEdit} handleClose={handleClose} /> : null}
      {isForm && !isView ? <SubscriptionPresetForm loadData={loadData} handleEdit={handleEdit} handleClose={handleClose} /> : null}
    </div>
  );
}
